import { requestApi } from "../../apiService";
import { ApiEndpoints } from "../../apiEndpoints";
import {
  AddReaction,
  AddReactionResponse,
  GetReactionsWithSignal,
  ReactionsResponse,
} from "@/server/types/umbra/reaction";

export const umbra_getMessageReactions = async ({
  chatId,
  messageId,
  emoji,
  cursor,
  signal,
}: GetReactionsWithSignal): Promise<ReactionsResponse> => {
  const response = await requestApi(
    {
      url: `${ApiEndpoints.UMBRA_MESSAGES}/${chatId}/messages/${messageId}/reactions${emoji ? `/${emoji}` : ""}`,
      method: "GET",
      params: { cursor },
      signal,
    },
    { retry429: true },
  );
  return response.data;
};

export const umbra_postMessageReaction = async ({
  chatId,
  messageId,
  emoji,
}: AddReaction): Promise<AddReactionResponse> => {
  const response = await requestApi({
    url: `${ApiEndpoints.UMBRA_MESSAGES}/${chatId}/messages/${messageId}/reactions`,
    method: "POST",
    data: { reaction: emoji },
  });
  return response.data;
};

export const umbra_deleteMessageReaction = async ({
  chatId,
  messageId,
  emoji,
}: AddReaction): Promise<void> => {
  await requestApi({
    url: `${ApiEndpoints.UMBRA_MESSAGES}/${chatId}/messages/${messageId}/reactions/${emoji}`,
    method: "DELETE",
  });
};
